













import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { getCookie } from "@szgc/plt-core-v2";
import { SzgcFormGetor } from "@/index";

@Component({
  name: "ReadFormPage",
  components: {
    SzgcFormGetor
  }
})
export default class ReadFormPage extends Vue {
  @Prop({
    type: Object,
    default() {
      return null;
    }
  })
  private dataAll!: any;

  private isEdit: boolean = false;
  private flowData: any = null;
  private formConfig: any = {
    auths: "",
    formRenderData: "",
    results: "",
    pacId: "",
    businessId: "",
    businessName: "",
    reqToken: ""
  };
  private reqToken: string = "";
  private prefix: string = "";

  @Watch("dataAll", { immediate: true, deep: true })
  private getData(newVal: any) {
    if (newVal) {
      this.prefix = getCookie("plt-api-route") || "";
      this.flowData = JSON.parse(JSON.stringify(newVal));
      this.reqToken = this.flowData.reqToken;
      this.formConfig = {
        ...this.flowData,
        auths: this.flowData.auths,
        formRenderData: this.flowData.formRender,
        results: this.flowData.fields,
        pacId: this.flowData.pacId,
        businessId: this.flowData.businessId,
        businessName: this.flowData.businessName,
        reqToken: this.reqToken
      };
    }
  }

  async getBack() {
    const allData = (await (this.$refs.webReadComponent as SzgcFormGetor).getFormValues()) as any;
    if (!allData.valid) {
      this.$message.error(allData.message ? allData.message : "获取表单数据失败，有必填项未填!");
      return false;
    }
    return allData;
  }
}
